module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap search-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "搜索商品",
      "id": "input"
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "focus": function($event) {
        return _vm.focusinput()
      },
      "blur": function($event) {
        return _vm.blurinput()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        return _vm.filter()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('span', {
    staticClass: "search-btn multiple",
    on: {
      "click": function($event) {
        _vm.rightPopup = true
      }
    }
  }, [_vm._v("筛选")])]), _vm._v(" "), (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "listBox",
    staticClass: "box flex-item"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_vm._l((_vm.goodsList), function(item) {
    return _c('div', {
      staticClass: "left-advertise square"
    }, [_c('div', {
      staticClass: "img",
      on: {
        "click": function($event) {
          return _vm.gotoSunhomeDetail(item.shareId)
        }
      }
    }, [_c('imgs', {
      attrs: {
        "titleText": item.shareContent,
        "imagePath": item && item.imagePath && item.imagePath.imagePath
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "userName ellipsis"
    }, [_vm._v("来自 " + _vm._s(item.shareBy) + " 的评价")]), _vm._v(" "), _c('p', {
      staticClass: "style-box flex-row"
    }, [_c('span', {
      staticClass: "style ellipsis flex-item"
    }, [_vm._l((item.tags), function(sub) {
      return [_vm._v(_vm._s(sub.linkName) + " ")]
    })], 2), _vm._v(" "), (item.totalPrice > 0) ? _c('span', {
      staticClass: "price ellipsis"
    }, [_vm._v(_vm._s(item.totalPrice) + "元")]) : _vm._e()])], 1)])
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  })], 2), _vm._v(" "), ((_vm.lastPageNo == _vm.pageNo && !_vm.load) || (_vm.total == 0 && !_vm.load)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多商品啦~")]) : _vm._e()]), _vm._v(" "), (_vm.isColligate) ? _c('div', {
    staticClass: "colligate-select"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('div', {
    staticClass: "radio-item",
    class: {
      active: _vm.asc == 'asc'
    },
    on: {
      "click": function($event) {
        return _vm.sale('asc')
      }
    }
  }, [_vm._v("销量从低到高")]), _vm._v(" "), _c('div', {
    staticClass: "radio-item",
    class: {
      active: _vm.asc == 'desc'
    },
    on: {
      "click": function($event) {
        return _vm.sale('desc')
      }
    }
  }, [_vm._v("销量从高到低")])])]) : _vm._e(), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "right",
      "popupClass": "filter-popup",
      "open": _vm.rightPopup
    },
    on: {
      "close": function($event) {
        _vm.rightPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-column"
  }, [_c('div', {
    staticClass: "filter-header"
  }, [_c('span', {
    staticClass: "arrow",
    on: {
      "click": function($event) {
        _vm.rightPopup = false
      }
    }
  }), _vm._v(" "), _c('samp', {}, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, _vm._l((_vm.GoodsPropertieTags), function(tag, index) {
    return _c('div', {
      ref: "toggleWrap",
      refInFor: true,
      staticClass: "item"
    }, [_c('p', {
      staticClass: "filter-list-header",
      on: {
        "click": function($event) {
          return _vm.toggleNexted(index)
        }
      }
    }, [_vm._v(_vm._s(tag.linkName)), (index >= _vm.eq) ? _c('samp', {
      staticClass: "arrow",
      class: {
        upArrow: index == _vm.nextId
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item",
      class: {
        spread: index < _vm.eq || index == _vm.nextId
      }
    }, _vm._l((tag.subs), function(subtag) {
      return _c('span', {
        staticClass: "label",
        class: {
          active: _vm.checkedTag && _vm.checkedTag[index] && _vm.checkedTag[index].linkInfo && _vm.checkedTag[index].linkInfo.linkTarget == subtag.linkTarget
        },
        on: {
          "click": function($event) {
            return _vm.selectTag(index, subtag)
          }
        }
      }, [_vm._v(_vm._s(subtag.linkName))])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('mu-raised-button', {
    staticClass: "reset-button",
    attrs: {
      "label": "重置",
      "primary": ""
    },
    on: {
      "click": _vm.reset
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submit-button",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": _vm.filter
    }
  })], 1)])]), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754a0872","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/sunhomelist.vue
// module id = 413
// module chunks = 68